export const BreadcrumbDividerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M8.80162 5.5685C8.51317 5.215 8.53359 4.69298 8.86314 4.36342C9.1927 4.03387 9.71472 4.01344 10.0682 4.3019L10.1366 4.36342L15.7225 9.94936C16.8548 11.0818 16.8548 12.9184 15.7225 14.0509L10.1366 19.6369L10.0682 19.6984C9.71472 19.9868 9.1927 19.9664 8.86314 19.6369C8.53359 19.3073 8.51317 18.7853 8.80162 18.4318L8.86314 18.3634L14.4491 12.7775C14.8785 12.3479 14.8785 11.6523 14.4491 11.2228L8.86314 5.63686L8.80162 5.5685Z"
        fill="#BDBDBD"
      />
    </svg>
  );
};
